import { darkThemes } from "../../constants/themes";
import styles from "./CApatienttable.module.scss";

export default function CAPatientTable({
  currentQuestion,
  getHighlightedText,
  theme,
}) {
  //canada mode not changed by themes, only light vs dark
  const darkMode = darkThemes.includes(theme);
  const header = `${styles.cell} ${styles.header} ${
    darkMode ? styles.headerDark : styles.headerLight
  }`;
  const q = currentQuestion.GetQuestion;
  const hasHistory = q.dental_history || q.medical_history;
  const hasFindings =
    q.clinical_findings || q.radiographic_findings || q.histological_findings;

  return (
    <table
      className={`${styles.table} ${darkMode ? styles.tableDark : styles.tableLight}`}
    >
      <tbody>
        <tr>
          <td className={header} data-id="patientHeader">
            <span data-id="container-break">
              {getHighlightedText("Patient", "patientHeader")}
            </span>
          </td>
        </tr>
        <tr>
          <td className={styles.cell} data-id="PatientAge">
            <span data-id="container-break">
              {getHighlightedText(
                `${q.patient_gender}, ${q.patient_age} year old`,
                "PatientAge",
              )}
            </span>
          </td>
        </tr>
        {q.chief_complaint && (
          <>
            <tr>
              <td className={header} data-id="chief_complaint_label">
                <span data-id="container-break">
                  {getHighlightedText(
                    "Chief Complaint",
                    "chief_complaint_label",
                  )}
                </span>
              </td>
            </tr>
            <tr>
              <td className={styles.cell} data-id="chief_complaint_text">
                <span data-id="container-break">
                  {getHighlightedText(
                    `"${q.chief_complaint}"`,
                    "chief_complaint_text",
                  )}
                </span>
              </td>
            </tr>
          </>
        )}
        {/* Background and/or Patient History = dental + medical history */}
        {hasHistory && (
          <tr>
            <td className={header} data-id="dental_history_label">
              <span data-id="container-break">
                {getHighlightedText(
                  "Background and/or Patient History",
                  "dental_history_label",
                )}
              </span>
            </td>
          </tr>
        )}
        {q.dental_history && (
          <tr>
            <td className={styles.cell} data-id="dental_history_text">
              <span data-id="container-break">
                {getHighlightedText(q.dental_history, "dental_history_text")}
              </span>
            </td>
          </tr>
        )}
        {q.medical_history && (
          <tr>
            <td className={styles.cell} data-id="medical_history_text">
              <span data-id="container-break">
                {getHighlightedText(q.medical_history, "medical_history_text")}
              </span>
            </td>
          </tr>
        )}
        {/* Current Findings = clinical + radiographic + histological */}
        {hasFindings && (
          <tr>
            <td className={header} data-id="clinical_findings_label">
              <span data-id="container-break">
                {getHighlightedText(
                  "Current Findings",
                  "clinical_findings_label",
                )}
              </span>
            </td>
          </tr>
        )}
        {q.clinical_findings && (
          <tr>
            <td className={styles.cell} data-id="clinical_findings_text">
              <span data-id="container-break">
                {getHighlightedText(
                  q.clinical_findings,
                  "clinical_findings_text",
                )}
              </span>
            </td>
          </tr>
        )}
        {q.radiographic_findings && (
          <tr>
            <td className={styles.cell} data-id="radiographic_findings_text">
              <span data-id="container-break">
                {getHighlightedText(
                  q.radiographic_findings,
                  "radiographic_findings_text",
                )}
              </span>
            </td>
          </tr>
        )}
        {q.histological_findings && (
          <tr>
            <td className={styles.cell} data-id="histological_findings_text">
              <span data-id="container-break">
                {getHighlightedText(
                  q.histological_findings,
                  "histological_findings_text",
                )}
              </span>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
